import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import PublicationHeatMap from "./tabs/PublicationHeatMap";
import { VotesSpread } from "../HistoricalReports/tabs";
import Layout from "../../../components/layout/Layout";
import { ProfileDetails } from "../../../containers/ProfileDetails";
import FilterableTabCard from "../../../components/tabs/FilterableTabCard";
import CustomDrawer from "../../../components/layout/CustomDrawer";
import FilterPanel from "../../../components/filters/FilterPanel";
import PublicationSchedule from "./tabs/PublicationSchedule";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
    useGetAnalystDetailQuery,
    useGetDynamicFilterOptionsQuery,
} from "../../../redux/service/modules/dashboard";
import CommonNavigator from "../../../components/common/CommonNavigator";
import moment from "moment";
import { getDynamicFilterOptions } from "../../../utils/commonUtils";
import AnalystVotesSpread from "./tabs/AnalystVotesSpread";
import ServiceTouchPoints from "./tabs/ServiceTouchPoints";
import Loader from "../../../components/common/loader";

const AnalystEngagement = () => {
    const dateRange = useSelector((state) => state.date);
    const [isFilterOpen, toggleFilter] = useState(false);
    const [filters, setFilters] = useState([]);
    const [staticFiltersData, setStaticFiltersData] = useState([]);
    const [requiredFilters, setRequiredFilters] = useState([]);
    const { id } = useParams();
    const [activeTab, setActiveTab] = useState(0);

    const {
        data: analystDetail,
        error,
        isLoading,
    } = useGetAnalystDetailQuery({ id, ...dateRange });
    const currentDate = moment();
    const lastTwoFinancialYears = moment().subtract(2, "years").startOf("year");
    const defaultFilters = {
        appliedFilters: {
            initialDateRange: {
                startDate: lastTwoFinancialYears,
                endDate: currentDate,
            },
            analyst_id: id,
        },
    };
    const [filterDetails, setFilterDetails] = useState({ ...defaultFilters });
    const {
        data: dynamicFilterOptions,
        error: filterError,
        isLoading: filterLoading,
    } = useGetDynamicFilterOptionsQuery({
        filters: ["report_type", "clients", "tiers", "sector"],
    });

    useEffect(() => {
        setFilterDetails({
            appliedFilters: {
                initialDateRange: dateRange,
                analyst_id: id,
            },
        });
    }, [dateRange, id]);

    const onFilterApply = (filtersVal, filterCount, rawFilters) => {
        toggleFilter(false);
        setFilterDetails({
            appliedFilters: { ...filtersVal, analyst_id: id },
            filterCount,
            rawFilters,
        });
    };

    useEffect(() => {
        getDynamicFilterOptions(
            dynamicFilterOptions,
            setFilters,
            setStaticFiltersData
        );
    }, [dynamicFilterOptions]);

    useEffect(() => {
        // if(requiredFilters) {
        setStaticFiltersData((filters) => {
            setFilters(
                filters.filter((filter) => requiredFilters.includes(filter.key))
            );
            return filters;
        });

        // }
    }, [requiredFilters]);
    const statsRow = [
        {
            rank: analystDetail?.details?.publication_rank || " - ",
            total: analystDetail?.details?.total_analyst,
            label: "Publication",
        },
        {
            rank: analystDetail?.details?.vote_rank || " - ",
            total: analystDetail?.details?.total_analyst,
            label: "Votes",
        },
        {
            rank: analystDetail?.details?.interaction_rank || " - ",
            total: analystDetail?.details?.total_analyst,
            label: "Service Intensity",
        },
        {
            rank: " - ",
            total: analystDetail?.details?.total_analyst,
            label: "Revenue",
        },
        {
            rank: analystDetail?.details?.weighted_score || " - ",
            total: analystDetail?.details?.weighted_score,
            label: "Average Weighted Votes",
        },
        // {
        //     rank: " - ",
        //     total: analystDetail?.details?.total_analyst,
        //     label: "Readership",
        // },
        {
            rank: 2,
            total: analystDetail?.details?.coverage_ticker,
            label: "Coverage",
        },
        {
            rank: 0,
            total: analystDetail?.details?.initiation,
            label: "Initiation",
        },
        {
            rank: 3,
            total: analystDetail?.details?.thematic,
            label: "Thematics",
        },
        {
            rank: 2,
            total: analystDetail?.details?.ci,
            label: "CI's",
        },
        {
            rank: analystDetail?.details?.total_votes || " - ",
            total: analystDetail?.details?.total_votes,
            label: "Average Overall Votes",
        },
    ];

    const tabs = [
        {
            label: "Publications History",
            content: PublicationHeatMap,
            showFilter: false,
            showDateRange: false,
        },
        {
            label: "Publications Schedule",
            content: PublicationSchedule,
            showFilter: true,
            showDateRange: false,
        },
        {
            label: "Service Touchpoints",
            content: ServiceTouchPoints,
            showFilter: true,
            showDateRange: false,
        },
        {
            label: "Historical Votes",
            content: AnalystVotesSpread,
            showFilter: true,
            showDateRange: false,
        },
    ];

    const firstRow = statsRow.slice(0, Math.floor(statsRow.length / 2));
    const secondRow = statsRow.slice(
        Math.floor(statsRow.length / 2),
        Math.floor(statsRow.length)
    );

    const handleTabChange = (newValue) => {
        setActiveTab(newValue);
        setFilterDetails({ ...defaultFilters });
    };

    if (isLoading) return <Loader isFullPage={true} />;
    if (error) return <div>Error loading analyst details</div>;
    return (
        <Layout>
            <Box>
                <div className="mb-2">
                    <CommonNavigator
                        title={"Analyst Engagement"}
                        showBackButton
                    />
                </div>
                <ProfileDetails data={{ firstRow, secondRow, analystDetail }} />

                <FilterableTabCard
                    tabs={tabs}
                    onTabClick={handleTabChange}
                    onFilterClick={() => toggleFilter(true)}
                    appliedFilters={filterDetails.appliedFilters}
                    filterCount={filterDetails.filterCount}
                    isShowFilter={false}
                    setRequiredFilters={setRequiredFilters}
                    value={activeTab}
                />
                <CustomDrawer open={isFilterOpen}>
                    <FilterPanel
                        filtersContent={filters}
                        handlePanelClose={() => toggleFilter(false)}
                        onApply={onFilterApply}
                        appliedFilters={filterDetails.rawFilters}
                    />
                </CustomDrawer>
            </Box>
        </Layout>
    );
};

export default AnalystEngagement;
